import React from 'react'

import {
  InfoCardContainer,
  InfoCardHeader,
  HeaderTitle,
  ContentTitle
} from './styles'

interface FakeChartCardProps {
  title: string
  content: number | string
}

const FakeChartCard: React.FC<FakeChartCardProps> = ({ title, content }) => {
  return (
    <>
      <InfoCardContainer>
        <InfoCardHeader>
          <HeaderTitle>{title.toUpperCase()}</HeaderTitle>
        </InfoCardHeader>
        <ContentTitle>{content}</ContentTitle>
      </InfoCardContainer>
    </>
  )
}

export default FakeChartCard
